import React from 'react';
import { useProfileMetrics } from '@/hooks/useProfileMetrics';
import {
  EmojiEvents,
  LocalFireDepartment,
  LocationPin,
  MonitorHeart,
  Route,
  ThumbUp,
} from '@mui/icons-material';
import theme from '@/constants/theme';
import useLearningRoutes from '@/context/routes/hook';
import useUser from '@/hooks/useUser';

const ActivityStats = () => {
  // const totalRecords = data?.totalRecords || 0;
  // const totalVideos = data?.videosWatched || 0;
  // const totalRoutes = data?.routesInProgress || 0;
  // const totalExercises = data?.guidedExercises || 0;
  const { user } = useUser();
  const { routesList } = useLearningRoutes();

  const amountOfCompletedRoutes =
    routesList.filter((route) => route.progressStatus === 'COMPLETED').length || 0;
  const userPoints = user?.points || 0;
  const amountOfProgressRoutes =
    routesList.filter((route) => route.progressStatus === 'IN_PROGRESS').length || 0;

  return (
    <div style={styles.container}>
      <p style={styles.title}>Progreso en rutas</p>
      <div style={styles.statsContainer}>
        <div style={styles.statContainer}>
          <p style={styles.statLabel}>Puntos obtenidos</p>
          <div style={styles.stastValueContainer}>
            <EmojiEvents style={{ color: theme.colors.points, width: 32, height: 32 }} />
            <p style={styles.statValue}>{userPoints}</p>
          </div>
        </div>
        <div style={styles.statContainer}>
          <p style={styles.statLabel}>Rutas completadas</p>
          <div style={styles.stastValueContainer}>
            <Route style={{ color: '#2f9c0b', width: 32, height: 32 }} />
            <p style={styles.statValue}>{amountOfCompletedRoutes}</p>
          </div>
        </div>
        <div style={styles.statContainer}>
          <p style={styles.statLabel}>Rutas en progreso</p>
          <div style={styles.stastValueContainer}>
            <LocalFireDepartment style={{ color: '#e64a2c', width: 32, height: 32 }} />
            <p style={styles.statValue}>{amountOfProgressRoutes}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    color: theme.colors.text.default,
  },
  statsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    flexWrap: 'wrap',
  },
  statContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.background.secondary,
    padding: '16px 24px',
    borderRadius: 10,
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: 100,
    gap: 8,
  },
  stastValueContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  statValue: {
    color: theme.colors.text.default,
  },
  statLabel: {
    color: theme.colors.text.caption,
    textAlign: 'center',
    fontSize: 14,
  },
};

export default ActivityStats;